import React from 'react';
const Forgot = () => (
  <> 
 <div id="kt_body" class="auth-bg">
	<div class="d-flex flex-column flex-root">			
			<div class="d-flex flex-column flex-column-fluid flex-lg-row">
		
				<div class="d-flex flex-center w-lg-50 pt-15 pt-lg-0 px-10">
				
					<div class="d-flex flex-center flex-lg-start flex-column mobile-none">
			
						<a href="/" class="mb-7">
							<img src="/assets/images/logo.png" alt="img" className='logo_login' />
						</a>
						<h2 class="text-white fw-normal m-0">Branding tools designed for your business</h2>
			
					</div>
				</div>
        <div class="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
			
					<div class="bg-body d-flex flex-column align-items-stretch flex-center rounded-4 w-md-500px p-10">
		
						<div class="d-flex flex-center flex-column flex-column-fluid px-lg-0">
							
							<form class="form w-100" novalidate="novalidate" id="kt_password_reset_form" data-kt-redirect-url="authentication/layouts/creative/new-password.html" action="#">
							
								<div class="text-center mb-10">
									<img src="/assets/images/logo.png" alt="img" className='logo_login mb-10 desk-none' />
									<h1 class="text-gray-900 fw-bolder mb-3">Forgot Password ?</h1>
							
									<div class="text-gray-500 fw-semibold fs-6">Enter your email to reset your password.</div>
									
								</div>
								<div class="fv-row mb-8">
									<input type="text" placeholder="Email" name="email" autocomplete="off" class="form-control bg-transparent" />
								
								</div>
								<div class="d-flex flex-wrap justify-content-center pb-lg-0">
									<button type="button" id="kt_password_reset_submit" class="btn btn-primary me-4">
							
										<span class="indicator-label">Submit</span>
										<span class="indicator-progress">Please wait... 
										<span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
										
									</button>
									<a href="/login" class="btn btn-light">Cancel</a>
								</div>
							</form>
						</div>
						
					</div>
				</div>
				
			</div>
		</div>
		</div>


  </>
   
);

export default Forgot;
